import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { FileText, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden mt-[-85px] mb-[-85px]" data-id="element-132">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-green/20 blur-[120px] rounded-full pointer-events-none" data-id="element-133" />

      <div className="container mx-auto px-4 relative z-10 pt-[35px] pb-[35px] mt-[-35px]" data-id="element-134">
        <div className="max-w-4xl mx-auto text-center" data-id="element-135">
          {/* Brand Name - Prominent */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="md:mb-10 mb-[15px]" data-id="element-136">
            <span className="inline-flex items-center gap-2 text-brand-light font-bold sm:text-3xl md:text-4xl tracking-wider text-[18px] mt-[-40px] mb-[-24px] font-[Poppins,_sans-serif]" data-id="element-137">
              🌿 BIOMA LÍVIDO™
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-5 md:mb-8" data-id="element-138">
            <h1 className="sm:text-5xl md:text-6xl lg:text-7xl font-bold md:mb-2 text-[24px] mt-[-10px] mb-[-10px] pt-[5px] pb-[5px] font-[Poppins,_sans-serif]" data-id="element-139">
              Dormí sin ardor y despertá sin fuego en{' '}
              <span className="text-brand-light" data-id="element-140">30 días.</span>
            </h1>
            <p className="sm:text-3xl md:text-4xl lg:text-5xl font-bold mt-1 md:mt-2 text-[20px] mb-[-45px] font-[Poppins,_sans-serif] text-[#FFFFFF]" data-id="element-141">
              Sin omeprazol de por vida. Sin resignarte a que esto sea normal.
            </p>
          </motion.div>

          {/* Product Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative max-w-[16rem] md:max-w-lg mx-auto mb-5 md:mb-12" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/pMNFoTXE6vpHWXavhwnNTL/Mockup_-_SN4.png" alt="Sistema Escudo Gástrico Mockup" className="w-full h-auto drop-shadow-2xl md:mt-[-35px] md:mb-[-35px] mt-[-30px] mb-[-30px] pt-[10px] pb-[10px]" data-id="element-143" />
          </motion.div>

          {/* Subtitle & Description */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mb-4 md:mb-6" data-id="element-144">
            <h2 className="text-brand-gold font-bold sm:text-xl md:text-2xl mb-3 md:mb-4 text-[16px]" data-id="element-145">
              SISTEMA ESCUDO GÁSTRICO™
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-200 leading-relaxed px-2 max-w-2xl mx-auto mt-[-10px] mb-4" data-id="element-146">
              El primer sistema de 6 tomos para la mujer argentina con reflujo y
              acidez crónica que quiere acostarse sin miedo y recuperar la
              libertad digestiva.
            </p>
          </motion.div>

          {/* Feature Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-2 md:gap-3 md:mb-10 text-xs md:text-sm font-medium text-gray-300 mt-[20px] mb-[20px]" data-id="element-147">
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-148">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-light" data-id="element-149" />
              100% PDF
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-150">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-151" />
              Acceso en 5 min
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-152">
            <Button href="#pricing" showBadges className="text-base md:text-xl py-5 md:py-6 px-6 md:px-10 w-full max-w-lg mb-5 md:mb-6 font-bold" data-id="element-153">
              🌿 QUIERO MI SISTEMA ESCUDO GÁSTRICO AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}